import React from "react"

import Board_Manager from "../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"
import FieldFormula from "../../formula"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {
            value: number
        }
        children        : {
            value: number
        }
        total           : {
            value: number
        }

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldFormula_BoardAggregate"
const debug = false

export default function FieldFormula_BoardAggregate(props: Props) {

    const value     = props.calculatedData?.total.value
    const isValid   = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', isValid, value, props.calculatedData, props.field)

    let currencyMark
    let valueLabel

    const showLabel = isValid && !!value
    if (showLabel) {
        const field: FieldFormula = props.field as FieldFormula
        switch (field.formatType) {
            case 'currency':
                currencyMark = gd.const.currency[field.symbolId!]?.symbol || null
                break
        }

        valueLabel = props.field?.getDisplayValue(typeof value === 'number' ? value : parseFloat(value))
    }

    const classes = Classes("left-aligned flex-no-shrink max-w-130", props.className, {
        'show-on-hover': !showLabel
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
            hint        = {valueLabel}
        >
            <div className="flex-row-left-center txt-truncate">
                <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                <div className="ui5-txt-not-important-small txt-truncate">
                    {currencyMark} {valueLabel}
                </div>
            </div>
        </Board_AggregateShell>
    )
}
